import { useState } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Pricing page components
import FaqCollapse from "pages/about-us/company/Career/components/FaqCollapse";

function Faq() {
  const [collapse, setCollapse] = useState(false);

  const faqItems = [
    {
      title: "¿Cómo puedo aplicar?",
      content: `¿Listo para dar el primer paso? Simplemente envíanos un correo electrónico a info@pwncat.com,
                y nos aseguraremos de que recibas un paquete completo con todos los detalles esenciales
                que necesitas para iniciar tu proceso de aplicación. ¡Es así de simple!`,
    },
    {
      title: "¿Qué calificaciones necesito para aplicar a un trabajo?",
      content: `En PWNCAT, creemos en brindar oportunidades a personas de diversos antecedentes y
                niveles de habilidad. No requerimos calificaciones formales específicas para aplicar a la mayoría de nuestros puestos.
                Valoramos las experiencias diversas y reconocemos que las habilidades y el potencial pueden provenir de una amplia gama de fuentes.
                Nuestro enfoque está en encontrar personas entusiastas, motivadas y alineadas con los valores de nuestra empresa.
                Damos la bienvenida a candidatos que estén ansiosos por aprender, contribuir y crecer dentro de nuestra organización.
                Si bien no tenemos requisitos educativos estrictos, buscamos cualidades y atributos que
                se ajusten al rol que te interesa.
                Al aplicar, es útil enfatizar cualquier experiencia relevante, habilidades y pasiones que te hagan
                un buen candidato para el puesto. Nuestro objetivo es crear un equipo dinámico con una mezcla de perspectivas y
                capacidades, asegurando un entorno de trabajo colaborativo e innovador.
                Así que, ya seas un recién graduado, estés cambiando de carrera o aportes una gran experiencia práctica,
                te animamos a aplicar y mostrar cómo podrías ser una valiosa adición a nuestro equipo. Si tienes alguna
                pregunta sobre cómo tu experiencia se ajusta a un rol específico, no dudes en comunicarte con nuestro departamento de RRHH para
                orientación.`,
    },
    {
      title: "¿Ofrecen pasantías u oportunidades para principiantes?",
      content: `Valoramos el crecimiento y desarrollo de las personas en todas las etapas de sus carreras,
                incluidas aquellas que recién comienzan. Ofrecemos pasantías y oportunidades para principiantes cuando es posible. Sin embargo, es importante tener en cuenta que la disponibilidad de
                estas opciones puede variar según las consideraciones legales y logísticas de diferentes países.
                Crear pasantías a través de fronteras internacionales a veces puede plantear desafíos
                debido a complejidades legales y administrativas. Como resultado, aunque estamos ansiosos por
                brindar tales oportunidades, puede haber ocasiones en las que no podamos ofrecer
                pasantías o puestos para principiantes en ciertas ubicaciones.
                Recomendamos a los candidatos interesados en pasantías o roles para principiantes que estén atentos a nuestras listas de trabajos y se comuniquen con nuestro departamento de RRHH para obtener la información más reciente
                sobre las oportunidades disponibles en su región. En casos donde no sea factible crear pasantías debido a restricciones legales, aún alentamos a los candidatos en las primeras etapas de su carrera a explorar
                nuestras ofertas de trabajo regulares, ya que estos roles a menudo brindan oportunidades para el crecimiento y desarrollo de habilidades.
                Estamos comprometidos a fomentar una fuerza laboral diversa e inclusiva y apreciamos tu
                comprensión en situaciones donde factores logísticos o legales limitan nuestra capacidad para ofrecer
                ciertos tipos de puestos en ubicaciones específicas.`,
    },
    {
      title: "¿Cuánto tiempo suele durar el proceso de aplicación?",
      content: `La duración del proceso de aplicación varía según factores como la complejidad del rol y el volumen
                de aplicaciones. Después de aplicar, revisamos las presentaciones cuidadosamente y nos esforzamos por mantener a los candidatos informados
                sobre el estado de su aplicación. Si tu aplicación coincide con nuestros criterios, nos pondremos en contacto contigo para una entrevista,
                que generalmente ocurre dentro de unas pocas semanas. Después de la entrevista, finalizamos las selecciones y extendemos
                ofertas. Una vez aceptadas, nuestro proceso de incorporación comienza, generalmente abarcando unas pocas semanas. Si bien los plazos
                pueden diferir, aseguramos transparencia en cada etapa. No dudes en consultar con nuestro equipo de RRHH sobre los plazos específicos del rol. Apreciamos mucho tu paciencia durante el proceso mientras nos esforzamos por evaluar a todos
                los solicitantes a fondo.`,
    },
    {
      title: "¿Habrá pruebas de habilidades o evaluaciones durante el proceso de entrevista?",
      content: `Sí, para roles técnicos, incorporamos pruebas de habilidades y evaluaciones en el proceso de entrevista.
                Estas pruebas están diseñadas específicamente para los requisitos del rol y están diseñadas para evaluar
                tus capacidades prácticas.
                Creemos en evaluar tus habilidades en un contexto del mundo real. Por lo tanto, nuestras evaluaciones a menudo
                reflejan los desafíos que podrías encontrar en el trabajo real. Dependiendo del rol al que estés aplicando,
                podrías ser invitado a participar en ejercicios prácticos, simulaciones técnicas o
                escenarios de resolución de problemas.
                La complejidad de las evaluaciones puede variar según el puesto. Por ejemplo, si estás
                aplicando para un rol técnico, podrías encontrar pruebas prácticas inspiradas en plataformas
                como Hack The Box o evaluaciones que se asemejan al examen OSCP.
                Estas evaluaciones son valiosas tanto para ti como para nosotros. Te brindan la oportunidad
                de mostrar tus habilidades de manera tangible, mientras que nos ayudan a asegurar que estamos
                seleccionando candidatos que tienen las habilidades prácticas necesarias para sobresalir en el rol.
                Ten la seguridad de que te proporcionaremos instrucciones claras sobre qué esperar durante la
                fase de evaluación del proceso de entrevista. Si tienes alguna pregunta sobre las evaluaciones específicas relacionadas con el rol que te interesa, no dudes en comunicarte con
                nuestro equipo de RRHH. Estamos comprometidos a ofrecer un proceso de evaluación justo y completo
                para todos los solicitantes.`,
    },
  ];

  return (
    <MKBox component="section" py={6}>
      <Container>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={8}>
            <MKTypography variant="h2" align="center" fontWeight="bold" gutterBottom>
              Preguntas Frecuentes
            </MKTypography>
            <MKBox mb={2}>
              <MKTypography variant="body2" align="center" color="text">
                La sección de preguntas frecuentes te permitirá resolver algunas de tus dudas.
              </MKTypography>
            </MKBox>
          </Grid>
          <Grid item xs={12} md={10}>
            <Card>
              <MKBox py={2} px={3}>
                {faqItems.map((item, index) => (
                  <FaqCollapse
                    key={index}
                    title={item.title}
                    open={collapse === index + 1}
                    onClick={() => (collapse === index + 1 ? setCollapse(false) : setCollapse(index + 1))}
                  >
                    {item.content}
                  </FaqCollapse>
                ))}
              </MKBox>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Faq;